'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _invariant = require('invariant');

var _invariant2 = _interopRequireDefault(_invariant);

var _immutable = require('immutable');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = angular.module('ifeis.immutables', []).directive('immutable', function () {
  return {
    restrict: 'A',
    priority: 2000,
    scope: true,

    link: function link(scope, el, attrs) {
      var immutable = attrs.immutable,
          _attrs$array = attrs.array,
          array = _attrs$array === undefined ? false : _attrs$array;


      var toJS = function toJS(val) {
        if (array) {
          return val.toArray();
        }

        return val.toJS();
      };

      scope.$watch(immutable, function (val) {
        scope.immutable = val ? toJS(val) : null;
      });
    }
  };
}).filter('immutableFilter', function () {
  return function (array, exp) {
    if (!array || !exp || exp === "") return array;
    exp = exp.toString();

    (0, _invariant2.default)(Array.isArray(array), 'immutableFilter can only filter arrays.');
    (0, _invariant2.default)(typeof exp === 'string', 'immutableFilter can only filter by strings.');

    return array.filter(function (a) {
      a = a.toObject();
      return Object.getOwnPropertyNames(a).map(function (p) {
        return a[p];
      }).find(function (v) {
        return typeof v === 'string' && v.toLowerCase().indexOf(exp.toLowerCase()) > -1;
      });
    });
  };
}).filter('immutableOrderBy', function () {
  return function (array, prop) {
    var reverse = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

    if (!array) return array;

    (0, _invariant2.default)(Array.isArray(array), 'immutableOrderBy can only sort arrays.');
    (0, _invariant2.default)(typeof prop === 'string', 'immutableOrderBy can only sort by property names.');

    return array.sort(function (a, b) {
      return reverse ? b.get(prop).localeCompare(a.get(prop)) : a.get(prop).localeCompare(b.get(prop));
    });
  };
}).filter('immutableFilterByKeyValue', function () {
  return function (array, exp) {
    if (!array || !exp || exp === "") return array;
    exp = exp.toString();

    (0, _invariant2.default)(Array.isArray(array), 'immutableFilter can only filter arrays.');
    (0, _invariant2.default)(typeof exp === 'string', 'immutableFilter can only filter by strings.');

    return array.filter(function (a) {
      var val = a.get(exp.substring(0, exp.indexOf(':')));
      return val && val.toString() === exp.substring(exp.indexOf(':') + 1, exp.length);
    });
  };
}).filter('deepImmutableOrderBy', function () {
  return function (array, props) {
    var reverse = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

    if (!array) return array;

    (0, _invariant2.default)(Array.isArray(array), 'deepImmutableOrderBy can only sort arrays.');
    (0, _invariant2.default)(typeof props === 'string', 'deepImmutableOrderBy can only sort by property names.');

    var propArray = props.split(',');

    (0, _invariant2.default)(propArray.length == 2, 'Input props for deep immutable get in this function must be 2. Not more, not less.');
    (0, _invariant2.default)(propArray[1] && propArray[0], 'Input props for deep immutable get in this function must be a value.');

    return array.sort(function (a, b) {
      return reverse ? b.getIn([propArray[0], propArray[1]]).toString().localeCompare(a.getIn([propArray[0], propArray[1]]).toString()) : a.getIn([propArray[0], propArray[1]]).toString().localeCompare(b.getIn([propArray[0], propArray[1]]).toString());
    });
  };
});


//////////////////
// WEBPACK FOOTER
// ./immutables/index.js
// module id = 139
// module chunks = 0